<script>

import {axios} from '../mixins';
import NavTree from './NavTree.vue';


export default {

  name: 'Home',

  components: {NavTree},

  mixins: [axios],

  props: {
    activeYear: {
      required: false,
      type: Number,
      default: 2020,
    },
    range: {
      required: true,
      type: Object,
      default: [2000, 2030],
    },
  },

  data() {
    return {
      year: 2020,
      array: [],
    };
  },

  created() {
    this.year = this.activeYear
    this.load(this.year)
  },

  methods: {

    load(year) {
      this.get('/farms?year=' + year).then((response) => {
        this.year = year
        this.array = response.data.operational
      })
    },


  },
};

</script>

<template>
  <div class="flex flex-col">
    <NavTree :year="year" :range="range" @update="load">
      <slot name="nav-tree"></slot>
    </NavTree>
    <div class="container mx-auto flex flex-row">

      <div class="flex flex-col bg-grey-dark w-1/4 rounded-md mr-2">
        <div class="p-4 flex flex-col justify-center text-center text-white">
          <div class="text-xl font-semibold p-3 text-left">
            Farms ({{ array.length }})
          </div>
          <a v-for="farm in array" :href="`/farms/` + farm.id"
             class="w-full bg-grey hover:bg-grey-light font-semibold rounded-sm p-4 mb-3">{{ farm.name }}</a>
        </div>
      </div>

      <div class="flex flex-col bg-grey-dark w-1/4 rounded-md mr-2">
        <div class="p-4 flex flex-col justify-center text-center text-white">
          <div class="text-xl font-semibold p-3 text-left">
            Farms ({{ array.length }})
          </div>
          <a v-for="farm in array" :href="`/farms/` + farm.id"
             class="w-full bg-grey hover:bg-grey-light font-semibold rounded-sm p-4 mb-3">{{ farm.name }}</a>
        </div>
      </div>

      <div class="flex flex-col bg-grey-dark w-1/4 rounded-md mr-2">
        <div class="p-4 flex flex-col justify-center text-center text-white">
          <div class="text-xl font-semibold p-3 text-left">
            Farms ({{ array.length }})
          </div>
          <a v-for="farm in array" :href="`/farms/` + farm.id"
             class="w-full bg-grey hover:bg-grey-light font-semibold rounded-sm p-4 mb-3">{{ farm.name }}</a>
        </div>
      </div>

      <div class="flex flex-col bg-grey-dark w-1/4 rounded-md mr-2">
        <div class="p-4 flex flex-col justify-center text-center text-white">
          <div class="text-xl font-semibold p-3 text-left">
            Farms ({{ array.length }})
          </div>
          <a v-for="farm in array" :href="`/farms/` + farm.id"
             class="w-full bg-grey hover:bg-grey-light font-semibold rounded-sm p-4 mb-3">{{ farm.name }}</a>
        </div>
      </div>

    </div>

  </div>


</template>
